import { gql } from 'graphql-request';
import { client } from '@/graph/client';
import { MeInfo, MeResponse } from './types/Get';

class Me
{
    private data: MeInfo | undefined = undefined;

    public getId(): string
    {
        if(this.data)
        {
            return this.data.id;
        }

        return "missing";
    }

    public getName(): string
    {
        if(this.data)
        {
            return this.data.name;
        }

        return "missing";
    }

    public getKey(): string
    {
        if(this.data)
        {
            return this.data.key;
        }

        return "missing";
    }

    public getPermissions(): string[]
    {
        if(this.data)
        {
            return this.data.permissions;
        }

        return [];
    }

    public getSalesOrganisations(): string[]
    {
        if(this.data)
        {
            return this.data.salesOrganisations;
        }

        return [];
    }

    public async get(): Promise<MeInfo>
    {
        if(this.data)
        {
            return this.data;
        }

        const query = gql`
			{
                me {
                    id
                    name
                    key
                    permissions
                    salesOrganisations
                }
            }
		`;

        const response = await client.request<MeResponse>(query);

        console.log("Me.get", response);

        this.data = response.me;

        return response.me;
    }
}

export default new Me();
